import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Switch, Upload } from 'antd';
import * as Icon from "react-feather";
import { useDispatch } from 'react-redux';
import appLoaderAction from '../../../redux/action/app-loader-action';
import notifyUtitls from '../../../utils/notify-utils';
import videoGalleryService from '../../../services/video-gallery-service';
import { fileTYPE_VIDEO } from '../../../constants/app-constants';

const AddEditVideoDialog = ({ isShow, onCancel, onSaveComplete, editData, currentParent, currentFolder, currentPath }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [file, setFile] = useState(null);
    const [videoShow, setVideoShow] = useState(null);

    useEffect(() => {
        if (!isShow) {
            setFile(null);
            setVideoShow(null);
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            form.setFieldsValue({
                shortDescription: editData.shortDescription,
                enable: editData.enable
            });
            setVideoShow(editData.fileName);
        } else {
            form.setFieldsValue({
                shortDescription: null,
                enable: true
            });
        }
    }, [isShow, editData]);

    const onSave = async () => {
        try {
            let path = "/"
            const values = await form.validateFields();
            const formData = new FormData();
            if (currentParent === "root") {
                formData.append("parent", currentParent);
                formData.append("path", "");
            } else {
                formData.append("parent", currentParent);
                currentPath.forEach((res) => {
                    path = path + res + "/";
                });

                formData.append("path", path);
            }
            formData.append("enable", values.enable);
            formData.append("shortDescription", values.shortDescription);
            formData.append("file", file);

            try {
                dispatch(appLoaderAction.enable());
                if(!editData){
                    await videoGalleryService.add(formData);
                } else {
                    let bean = JSON.parse(JSON.stringify(editData));
                    formData.append("id", bean.id);
                    // bean.shortDescription = values.shortDescription;
                    // bean.enable = values.enable;
                    
                    // const editResult = {
                    //     bean: {
                    //         ...bean
                    //     }
                    // }
                    await videoGalleryService.edit(formData);
                }
                dispatch(appLoaderAction.disale());
                onSaveComplete();
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');
            }  catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
			}
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        }
    }

    const handleUpload = (file)=>{
        setFile(file);
        setVideoShow(file.name);
        return false;
    }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขวีดีโอ' : 'เพิ่มวีดีโอ'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave}>
                            <Icon.Save className="me-2" size={17} />{editData ? 'บันทึก' : 'เพิ่มวีดีโอ'}
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            <Icon.X className="me-2" size={17} />ยกเลิก
                        </Button>,
                    ]}>
                    <Form
                        layout="vertical"
                        name="add_edit_banner"
                        preserve={false}
                        form={form}
                        initialValues={{status: true, enableNewTab: true}}>

                        <Form.Item 
                            key="image"
                            label="วีดีโอ" 
                            name="image"
                        >
                            {
                                editData ? (
                                    <Upload
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={handleUpload}
                                        accept={fileTYPE_VIDEO}
                                    >
                                        Click for edit
                                    </Upload>  
                                ) : (
                                    <Upload
                                        listType="picture-card"
                                        showUploadList={false}
                                        beforeUpload={handleUpload}
                                        accept={fileTYPE_VIDEO}
                                    >
                                        Click for Upload
                                    </Upload>
                                )
                            }
                            <div>
                                <a download>{videoShow}</a> 
                            </div>
                        </Form.Item>

                        <Form.Item
                            key="shortDescription"
                            label="คำอธิบาย"
                            name="shortDescription"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input />
                        </Form.Item>

                        <Form.Item label="การแสดง" name="enable" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    )
}

export default AddEditVideoDialog;
